import React from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

/**
 * PageTransition — pathname-keyed wrapper that fades each new route in via
 * a pure CSS animation. Replaced the previous motion/AnimatePresence
 * implementation to keep the motion library out of the main bundle (~50 KB
 * gzipped). The CSS keyframe pauses under prefers-reduced-motion.
 */
const PageTransition = ({ children }) => {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition">
      {children}
    </div>
  );
};

export default PageTransition;
